module.exports = __webpack_public_path__ + "media/images/logos/factorial_hr-2d7b2c4d6d157c9d09ca48de49618ff6.png";